module.exports = __webpack_public_path__ + "static/media/cash-register.f589ef17.svg";